import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {KeycloakService} from "./app/core/services/keycloak.service";
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

KeycloakService.init().then(data => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}).catch(error => {
});



// WEBPACK FOOTER //
// ./src/main.ts